module.exports = __webpack_public_path__ + "static/img/bg.0b1f10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/bg.png
// module id = 25Ux
// module chunks = 1